import { put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { IPatientVitals } from '../store/vitals.types'
import { setStrokeScaleScoreTotal } from '../store/vitals.actions'

export function* setNihPositiveStrokeScaleScoreMap() {
  const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)
  const { nihPositiveStrokeScaleScoreMap } = patientVital
  patientVital.nihPositiveStrokeScaleScoreMap = nihPositiveStrokeScaleScoreMap
  if (nihPositiveStrokeScaleScoreMap.size) {
    let totalStrokeScaleScore = 0
    nihPositiveStrokeScaleScoreMap.forEach((option) => {
      totalStrokeScaleScore = totalStrokeScaleScore + (option.id || 0)
    })
    yield put(setStrokeScaleScoreTotal(totalStrokeScaleScore))
  } else {
    yield put(setStrokeScaleScoreTotal(null))
  }
}

export function* setNihPositiveStrokeScaleScoreMapSaga() {
  yield takeLatest([VitalsConstants.SET_NIH_POSITIVE_STROKE_SCALE_SCORE_MAP], setNihPositiveStrokeScaleScoreMap)
}
